import { getData } from '../../DataAccessLayer';
import { sam } from '../../DataAccessLayer/services';

export const checkJobStatus = async (
  saveIsAutomatedJobCompleted,
  saveIsCheckingAutomatedJobStatus,
  saveProcessingJobs,
) => {
  try {
    saveIsCheckingAutomatedJobStatus(true);
    const { allCompleted, processingJobs } = await getData(sam.batch().autoJob.status, true);

    saveIsAutomatedJobCompleted(allCompleted);
    saveProcessingJobs(processingJobs);

    return allCompleted;
  } catch (err) {
    console.log(err);
  } finally {
    saveIsCheckingAutomatedJobStatus(false);
  }
};
